import { Star, Users, Car, Stethoscope } from "lucide-react";

const items = [
  {
    icon: Star,
    label: "تقييم جوجل",
    value: "4.7 / 5",
    sub: "تقييم ممتاز",
    color: "text-amber-400",
  },
  {
    icon: Users,
    label: "مراجعات العملاء",
    value: "+474",
    sub: "رضا موثّق",
    color: "text-cyan-400",
  },
  {
    icon: Car,
    label: "نخدم",
    value: "جميع السيارات",
    sub: "قديم وحديث",
    color: "text-cyan-400",
  },
  {
    icon: Stethoscope,
    label: "قبل الإصلاح",
    value: "تشخيص احترافي",
    sub: "نحدد العطل بدقة",
    color: "text-cyan-400",
  },
];

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="relative -mt-12 lg:-mt-20 z-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="rounded-2xl lg:rounded-3xl border border-slate-800/80 bg-slate-900/70 backdrop-blur-xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-slate-800/80 rtl:divide-x-reverse">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <div
                  key={i}
                  className="p-5 lg:p-7 flex items-center gap-4 hover:bg-slate-900/90 transition-colors"
                >
                  <div className="w-11 h-11 lg:w-12 lg:h-12 rounded-xl bg-slate-950 border border-slate-800 flex items-center justify-center flex-shrink-0">
                    <Icon
                      className={`w-5 h-5 lg:w-6 lg:h-6 ${it.color} ${
                        it.icon === Star ? "fill-amber-400" : ""
                      }`}
                    />
                  </div>
                  <div className="min-w-0">
                    <div className="text-[11px] lg:text-xs uppercase tracking-wider text-slate-500">
                      {it.label}
                    </div>
                    <div className="text-base lg:text-lg font-bold text-white truncate">
                      {it.value}
                    </div>
                    <div className="text-xs text-slate-400">{it.sub}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
